module.exports = __webpack_public_path__ + "static/media/2-FALK.56a9f4e5.mp3";